
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensary/[cName]/collections/[slug]",
      function () {
        return require("private-next-pages/dispensary/[cName]/collections/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensary/[cName]/collections/[slug]"])
      });
    }
  